import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import BriaBadge from "../BriaBadge/BriaBadge";
import styles from "./IntegrationIconCard.module.scss";

export interface IntegrationIconCardProps {
	icon: string;
	label?: string;
	link?: string;
	badgeLabel?: string;
	openInNewTab?: boolean;
	className?: string;
	onClick?: () => void;
}

export const IntegrationIconCard = ({
	icon,
	label,
	link,
	badgeLabel,
	className,
	openInNewTab = true,
	onClick,
}: IntegrationIconCardProps) => {
	const cardContent = (
		<div>
			<img className={styles.icon} src={icon} alt={label} />
			{label && <Typography className={styles.label}>{label}</Typography>}
			{badgeLabel && <BriaBadge className={styles.badge} label={badgeLabel} />}
		</div>
	);

	if (link) {
		return (
			<NavLink
				className={`${styles.clickableCard} ${className || ""}`}
				to={link}
				target={openInNewTab ? "_blank" : undefined}
				rel={openInNewTab ? "noopener noreferrer" : undefined}
			>
				{cardContent}
			</NavLink>
		);
	}

	return (
		<Box className={`${onClick ? styles.clickableCard : styles.card} ${className || ""}`} onClick={onClick}>
			{cardContent}
		</Box>
	);
};
